<template>
  <div class="light-detail">
    <!-- 返回按钮 -->
    <div class="header">
      <div class="back-btn" @click="goBack">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#333" stroke-width="2">
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        <span>返回</span>
      </div>
    </div>

    <!-- 图片展示区 - 轮播 -->
    <div class="image-section">
      <van-swipe 
        class="light-swipe" 
        indicator-color="rgba(255,255,255,0.5)"
        indicator-active-color="#fff"
        :loop="lightImages.length > 1"
        @change="onSwipeChange"
      >
        <van-swipe-item 
          v-for="(img, idx) in lightImages" 
          :key="idx"
          @click="previewImage(idx)"
        >
          <div class="image-container">
            <img :src="img" alt="" class="detail-image" @error="handleImageError(idx)" />
            <div v-if="failedImages[idx]" class="image-placeholder">
              <svg viewBox="0 0 24 24" width="48" height="48" fill="#ddd">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
              </svg>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
      <!-- 图片数量标识 -->
      <div class="image-count" v-if="lightImages.length > 1">
        {{ currentIndex + 1 }} / {{ lightImages.length }}
      </div>
    </div>

    <!-- 详情信息 -->
    <div class="info-section">
      <div class="info-header">
        <div class="material-code">{{ lightInfo.materialCode }}</div>
      </div>
      <div class="material-desc">{{ lightInfo.materialDesc }}</div>
      
      <!-- 标签 -->
      <div class="tags-section">
        <span 
          class="tag" 
          v-for="(tag, idx) in getTags(lightInfo)" 
          :key="idx"
        >{{ tag }}</span>
      </div>

      <!-- 其他信息 -->
      <div class="detail-list">
        <div class="detail-item" v-if="lightInfo.tag1">
          <span class="detail-label">标签1:</span>
          <span class="detail-value">{{ lightInfo.tag1 }}</span>
        </div>
        <div class="detail-item" v-if="lightInfo.tag2">
          <span class="detail-label">标签2:</span>
          <span class="detail-value">{{ lightInfo.tag2 }}</span>
        </div>
        <div class="detail-item" v-if="lightInfo.tag3">
          <span class="detail-label">标签3:</span>
          <span class="detail-value">{{ lightInfo.tag3 }}</span>
        </div>
        <div class="detail-item" v-if="lightInfo.tag4">
          <span class="detail-label">标签4:</span>
          <span class="detail-value">{{ lightInfo.tag4 }}</span>
        </div>
        <div class="detail-item" v-if="lightInfo.tag5">
          <span class="detail-label">标签5:</span>
          <span class="detail-value">{{ lightInfo.tag5 }}</span>
        </div>
      </div>

      <!-- 上传附件区域 -->
      <div class="upload-section">
        <div class="upload-title">上传附件</div>
        <div class="upload-types">
          <div 
            class="upload-type-item" 
            v-for="(type, idx) in uploadTypes" 
            :key="idx"
            @click="chooseFile(type)"
          >
            <svg :viewBox="type.iconViewBox" width="48" height="48" :fill="type.color">
              <path :d="type.iconPath" />
            </svg>
            <span class="upload-type-name">{{ type.name }}</span>
            <span class="upload-type-desc">{{ type.desc }}</span>
          </div>
        </div>
        
        <!-- 已上传文件列表 -->
        <div v-if="uploadedFiles.length > 0" class="uploaded-list">
          <div 
            class="uploaded-item" 
            v-for="(file, idx) in uploadedFiles" 
            :key="idx"
          >
            <div class="uploaded-icon" :class="file.type">
              <svg v-if="file.type === 'image'" viewBox="0 0 24 24" width="32" height="32" fill="#409eff">
                <path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
              </svg>
              <svg v-else-if="file.type === 'pdf'" viewBox="0 0 24 24" width="32" height="32" fill="#f56c6c">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" width="32" height="32" fill="#e6a23c">
                <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"/>
              </svg>
            </div>
            <div class="uploaded-info">
              <div class="uploaded-name">{{ file.name }}</div>
              <div class="uploaded-size">{{ file.size }}</div>
            </div>
            <div class="uploaded-delete" @click="deleteUploaded(idx)">
              <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#999" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作 -->
    <div class="footer">
      <button class="action-btn">收藏</button>
      <button class="action-btn primary" @click="saveUploads">保存</button>
    </div>
    
    <!-- 隐藏的文件输入 -->
    <input 
      ref="fileInputRef" 
      type="file" 
      style="display: none;" 
      @change="handleFileChange"
    />
  </div>
</template>

<script>
import api from "@/apis/medal";
import { showLoading, hideLoading } from '@/utils/loading';
export default {
  name: "lightDetail",
  data() {
    return {
      lightInfo: {
        id: "",
        materialCode: "",
        materialDesc: "",
        image: "",
        tag1: "",
        tag2: "",
        tag3: "",
        tag4: "",
        tag5: "",
      },
      lightImages: [],
      loading: false,
      currentIndex: 0,
      failedImages: {},
      uploadedFiles: [],
      uploadTypes: [
        {
          name: "图片",
          desc: "JPG/PNG",
          color: "#409eff",
          iconViewBox: "0 0 24 24",
          iconPath: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z",
          accept: "image/jpeg,image/png,image/jpg",
        },
        {
          name: "文档",
          desc: "PDF",
          color: "#f56c6c",
          iconViewBox: "0 0 24 24",
          iconPath: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z",
          accept: "application/pdf",
        },
        {
          name: "视频",
          desc: "MP4",
          color: "#e6a23c",
          iconViewBox: "0 0 24 24",
          iconPath: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z",
          accept: "video/mp4,video/webm",
        },
      ],
      fileInputRef: null,
    };
  },
  created() {
    const dataStr = this.$route?.query?.data;
    if (dataStr) {
      try {
        const item = JSON.parse(decodeURIComponent(dataStr));
        this.lightInfo = item;
        this.formatImages(item.image);
        return;
      } catch (e) {
        console.error("解析路由参数失败:", e);
      }
    }
    const id = this.$route?.query?.id;
    if (id) {
      this.getDetail(id);
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    async getDetail(id) {
      this.loading = true;
      try {
        const params = {
          id: id,
        };
        const res = await api.getLightInfo(params);
        if (res.code === 200) {
          const data = res.data?.list?.[0] || {};
          this.lightInfo = data;
          // 处理图片URL
          this.formatImages(data.image);
        }
      } catch (error) {
        console.error("获取灯具详情失败:", error);
        this.$message.error("获取数据失败");
      } finally {
        this.loading = false;
      }
    },
    formatImages(imageStr) {
      if (!imageStr || typeof imageStr !== 'string') {
        this.lightImages = [];
        return;
      }
      const imageIds = imageStr.split(',').filter(id => id.trim());
      this.lightImages = imageIds.map(id => {
        const trimmedId = id.trim();
        if (trimmedId.startsWith('http://') || trimmedId.startsWith('https://')) {
          return trimmedId;
        }
        return `${api.imgUrl}${trimmedId}`;
      });
    },
    getTags(item) {
      const tags = [item.tag1, item.tag2, item.tag3, item.tag4, item.tag5];
      return tags.filter(Boolean);
    },
    previewImage(index) {
      if (this.lightImages.length === 0) return;
      const images = [...this.lightImages];
      images.splice(index, 1);
      images.unshift(this.lightImages[index]);
      this.$previewImage({
        images: images,
        startPosition: 0,
      });
    },
    handleImageError(index) {
      this.$set(this.failedImages, index, true);
    },
    onSwipeChange(index) {
      this.currentIndex = index;
    },
    chooseFile(type) {
      const input = this.$refs.fileInputRef;
      input.accept = type.accept;
      input.dataset.fileType = type.name === '图片' ? 'image' : type.name === '文档' ? 'pdf' : 'video';
      input.click();
    },
    async handleFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      const fileType = e.target.dataset.fileType;
      const fileName = file.name;
      const fileSize = this.formatFileSize(file.size);

      showLoading('上传中...');

      try {
        const formData = new FormData();
        formData.append('file', file);

        const res = await api.getUploadLight(formData);
        console.log('upload res:', res);

        if (res && res.id) {
          const fileId = res.id;
          this.uploadedFiles.push({
            id: fileId,
            name: fileName,
            size: fileSize,
            type: fileType,
            url: `/file/view/${fileId}`,
          });
          this.$message.success('上传成功');
        } else {
          this.$message.error(res.message || '上传失败');
        }
      } catch (error) {
        console.error('上传失败:', error);
        this.$message.error('上传失败，请重试');
      } finally {
        hideLoading();
        e.target.value = '';
      }
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    deleteUploaded(index) {
      this.uploadedFiles.splice(index, 1);
    },
    async saveUploads() {
      if (this.uploadedFiles.length === 0) {
        this.$message.warning('请先上传文件');
        return;
      }

      showLoading('保存中...');

      try {
        const params = {
          id: this.lightInfo.id,
        };

        const imageFiles = this.uploadedFiles.filter(f => f.type === 'image');
        const pdfFiles = this.uploadedFiles.filter(f => f.type === 'pdf');
        const videoFiles = this.uploadedFiles.filter(f => f.type === 'video');

        if (imageFiles.length > 0 || this.lightInfo.image) {
          const existingImages = this.lightInfo.image ? this.lightInfo.image.split(',').filter(id => id.trim()) : [];
          const newImageIds = imageFiles.map(f => f.id);
          params.image = [...new Set([...existingImages, ...newImageIds])].join(',');
        }
        if (pdfFiles.length > 0 || this.lightInfo.file) {
          const existingFiles = this.lightInfo.file ? this.lightInfo.file.split(',').filter(id => id.trim()) : [];
          const newFileIds = pdfFiles.map(f => `file_${f.id}`);
          params.file = [...new Set([...existingFiles, ...newFileIds])].join(',');
        }
        if (videoFiles.length > 0 || this.lightInfo.video) {
          const existingVideos = this.lightInfo.video ? this.lightInfo.video.split(',').filter(id => id.trim()) : [];
          const newVideoIds = videoFiles.map(f => `video_${f.id}`);
          params.video = [...new Set([...existingVideos, ...newVideoIds])].join(',');
        }

        const res = await api.updateLightInfo(params);
        if (res.code === 200) {
          this.$message.success('保存成功');
          this.uploadedFiles = [];
          this.getDetail(this.lightInfo.id);
        } else {
          this.$message.error(res.message || '保存失败');
        }
      } catch (error) {
        console.error('保存失败:', error);
        this.$message.error('保存失败，请重试');
      } finally {
        hideLoading();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.light-detail {
  min-height: 100vh;
  background: #fff;
  padding-bottom: 120px;
}

.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  
  @media screen and (min-width: 600px) {
    max-width: 600px;
  }
}

.back-btn {
  display: flex;
  align-items: center;
  font-size: 28px;
  color: #333;
  
  svg {
    margin-right: 8px;
  }
}

.image-section {
  padding-top: 60px;
  position: relative;
}

.light-swipe {
  height: 400px;
  background: #fff;
}

.light-swipe .van-swipe-item {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.detail-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.image-count {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 24px;
  padding: 6px 12px;
  border-radius: 20px;
}

.info-section {
  padding: 20px;
}

.info-header {
  margin-bottom: 15px;
}

.material-code {
  font-size: 36px;
  font-weight: 700;
  color: #333;
}

.material-desc {
  font-size: 28px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

.tags-section {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 30px;
}

.tag {
  font-size: 22px;
  padding: 8px 16px;
  background: #f0fdf4;
  color: #10b981;
  border-radius: 20px;
}

.detail-list {
  background: #f9f9f9;
  border-radius: 16px;
  padding: 15px;
}

.detail-item {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
  
  &:last-child {
    border-bottom: none;
  }
}

.detail-label {
  width: 120px;
  font-size: 26px;
  color: #999;
}

.detail-value {
  flex: 1;
  font-size: 26px;
  color: #333;
}

.upload-section {
  margin-top: 30px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 16px;
}

.upload-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
}

.upload-types {
  display: flex;
  gap: 20px;
}

.upload-type-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 15px;
  background: #fff;
  border-radius: 12px;
  border: 2px dashed #eee;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:active {
    transform: scale(0.95);
    border-color: #409eff;
  }
}

.upload-type-name {
  margin-top: 10px;
  font-size: 26px;
  color: #333;
  font-weight: 500;
}

.upload-type-desc {
  margin-top: 4px;
  font-size: 20px;
  color: #999;
}

.uploaded-list {
  margin-top: 20px;
}

.uploaded-item {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 10px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.uploaded-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
  margin-right: 15px;
  
  &.image {
    background: #ecf5ff;
  }
  
  &.pdf {
    background: #fef0f0;
  }
  
  &.video {
    background: #fdf6ec;
  }
}

.uploaded-info {
  flex: 1;
}

.uploaded-name {
  font-size: 26px;
  color: #333;
  margin-bottom: 4px;
}

.uploaded-size {
  font-size: 20px;
  color: #999;
}

.uploaded-delete {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  
  &:active {
    background: #f5f5f5;
    border-radius: 50%;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 20px;
  padding: 15px 20px;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  
  @media screen and (min-width: 600px) {
    max-width: 600px;
    margin: 0 auto;
  }
}

.action-btn {
  flex: 1;
  height: 80px;
  border: 1px solid #ddd;
  border-radius: 40px;
  font-size: 28px;
  color: #666;
  background: #fff;
  
  &.primary {
    background: #10b981;
    color: #fff;
    border: none;
  }
}

@media screen and (max-width: 600px) {
  .light-swipe {
    height: 300px;
  }
  
  .material-code {
    font-size: 32px;
  }
  
  .material-desc {
    font-size: 26px;
  }
  
  .tag {
    font-size: 20px;
    padding: 6px 12px;
  }
}
</style>